import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=550a08a3"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"
import style0 from "./NewBadge.vue?vue&type=style&index=0&id=550a08a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports